import { createClient } from '@/utils/saas/supabase/client'

// @@TODO: Wrap all database queries in useQuery / useMutation hooks
// @@BUG:
/*
Conversion of type 'undefined' to type 'Employee[]' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
Type 'undefined' is not comparable to type 'Employee'.ts(2352)
*/

// @@TODO: This is the correct and full implementation, apply this template to all functions

export interface PaymentMethod {
  id: number
  date_added: string
  payment_method: string
  paypal_email_address?: string
  creditcard_info?: string
  creditcard_expiration_date?: string
  primary: boolean
}

export type ExportFilterPaymentMethod = {
  id: number
  payment_method: string
  creditcard_expiration_date: string
  primary: boolean
}

export function prepareForExport(
  selection: PaymentMethod[],
): ExportFilterPaymentMethod[] {
  const filter: ExportFilterPaymentMethod[] = selection.map((row) => {
    const item: ExportFilterPaymentMethod = {
      id: row.id,
      payment_method: row.payment_method,
      creditcard_expiration_date: row.creditcard_expiration_date as string,
      primary: row.primary,
    }
    return item
  })
  console.log(prepareForExport.name + ' exportFilter=', filter)
  return filter
}

export const placeholderData: PaymentMethod[] = [
  {
    id: 0,
    date_added: '2010-01-01',
    payment_method: 'Credit Card',
    paypal_email_address: 'empty',
    creditcard_info: 'ending in 2492',
    creditcard_expiration_date: '2023-12-31',
    primary: false,
  },
]

export const deletePaymentMethod = async (id: number) => {
  try {
    const { data, error } = await createClient()
      .from('paymentmethods')
      .delete()
      .match({ id: id })

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return { success: !error }
    //return data as PaymentMethod[]
  } catch (error) {
    const message = String(error)
    console.log(message)
    throw error
  }
}

export const deletePaymentMethodList = async (ids: number[]) => {
  try {
    const { data, error } = await createClient()
      .from('paymentmethods')
      .delete()
      .in('id', ids)

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return { success: !error }
    //return data as PaymentMethod[]
  } catch (error) {
    const message = String(error)
    console.log(message)
    throw error
  }
}

export const getPaymentMethods = async () => {
  try {
    const { data, error } = await createClient().from('paymentmethods').select()

    if (error) {
      throw new Error(error.message)
    }
    if (!data) {
      throw new Error('no data')
    }
    return data as PaymentMethod[]
  } catch (error) {
    const message = String(error)
    console.log(message)
    throw error
  }
}
